import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import { fromJS } from 'immutable';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { getDialogContextValue } from '../../../redux/selectors';
import { toJS } from '../../../utils/helper';

import ReduxDialog from '../../Common/ReduxDialog/index';

import {
  sendTaskEmailFormHandler
} from '../../../redux/routines';

import { showDialog, hideDialog, showError } from '../../../redux/actions/dialogs';
import {
  renderTextField
} from '../../../utils/reduxforms';
import {
  SEND_EMAIL_DIALOG,
} from '../../../redux/constants/dialogs';

import styles from './styles';

class SendEmailDialog extends Component {
  render() {
    const { handleSubmit, hideDialog, submit } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        onClick={() => hideDialog(SEND_EMAIL_DIALOG)}
      >Cancel</Button>,
      <Button
        key="send"
        variant="contained"
        color="primary"
        autoFocus
        onClick={() => submit(SEND_EMAIL_DIALOG)}
      >Send</Button>];

    return (
      <ReduxDialog
        name={SEND_EMAIL_DIALOG}
        title="Send Email"
        actions={actions}
        bodyStyle={styles.body}
        fullWidth
        maxWidth="sm"
      >
        <Form onSubmit={handleSubmit(sendTaskEmailFormHandler)} style={styles.container}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Field
                name="to"
                label="To"
                component={renderTextField}
                disabled
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <Field
                name="subject"
                label="Subject"
                component={renderTextField}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <Field
                name="body"
                label="Body"
                component={renderTextField}
                fullWidth
                rows={8}
                multiline
              />
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

SendEmailDialog.propTypes = {
  // contact: PropTypes.object.isRequired,
};

const form = reduxForm({
  form: SEND_EMAIL_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog(SEND_EMAIL_DIALOG);
  },
})(SendEmailDialog);

function mapStateToProps(state, props) {
  // console.log('state', state);
  const contact = getDialogContextValue(state)(SEND_EMAIL_DIALOG, 'contact').toJS();
  console.log('contact', contact);
  return {
    initialValues: fromJS({
      to: contact.email,
      params: toJS(getDialogContextValue(state)(SEND_EMAIL_DIALOG, 'params')),
    }),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      showDialog,
      hideDialog,
      showError,
    }, dispatch),
    ...bindPromiseCreators({
      // saveCustomerLogo: saveCustomerLogoPromise,
    }, dispatch)
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Common/SendEmailDialog/index.js